import uniqueId from 'lodash/uniqueId';
import * as React from 'react';
export default (id: string, name: string = '') =>
  React.useState(`${id ? id : uniqueId(name)}`)[0];
